import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function Link({ href, linkTitle, iconClass, faIcon }) {
	return (
		<React.Fragment>
			<a
				className="link-class"
				href={href}
				target="_blank"
				rel="noreferrer"
				title={linkTitle}
			>
				<FontAwesomeIcon
					icon={faIcon}
					className={iconClass}
				/>
			</a>
		</React.Fragment>
	);
}
